@if (text) {
	<p
		class="au-body-text-heading"
		[class.pointer]="isClickable"
		[class.non-bold]="nonBold"
		(click)="$event.stopPropagation(); selectElement.emit()"
		[ngClass]="class"
	>
		<span class="body-text">{{ text }}</span>
		@if (iconConfig) {
			<span class="icons-container">
				<mat-icon
					[matTooltip]="iconConfig.tooltip"
					[svgIcon]="iconConfig.icon"
				></mat-icon>
			</span>
		}
	</p>
}

@if (!text) {
	<span
		class="no-data"
		[class.pointer]="isClickable"
		(click)="$event.stopPropagation(); selectElement.emit()"
	>
		{{ fallbackText }}
	</span>
}
